'use client';

import { useJsApiLoader } from '@react-google-maps/api';
import { useMemo } from 'react';

/** Shared loader ID so all Google Maps JS API usage in the app uses the same script instance. */
export const GOOGLE_MAPS_LOADER_ID = 'up2promo-google-maps';

/**
 * Centralized Google Maps JS API loader. Use this everywhere instead of useJsApiLoader directly
 * so loader id and options (language, region) are consistent. Avoids duplicate scripts and
 * conflicts when multiple map components mount (e.g. LocationMapPreview and GoogleMapsModuleDisplay).
 * Only call when apiKey is non-empty (e.g. conditionally render the component that uses this hook).
 */
export function useGoogleMapsLoader(apiKey: string) {
  const { language, region } = useMemo(() => {
    const lang = typeof navigator !== 'undefined' ? navigator.language : 'en';
    const parts = lang.split('-');
    return {
      language: lang,
      region: parts.length > 1 ? parts[1]?.toUpperCase() : undefined,
    };
  }, []);

  return useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: apiKey,
    language,
    region,
    nonce: undefined,
  });
}
